import GalleryDataViewer from "./GalleryDataViewer.js";
import TriggerSetup from "./queryTrigger/PluginSetup.js";
import ActionSetup from "./actions/PluginSetup.js";
import DefaultFiltersBlocker from "./DefaultFiltersBlocker.js";
export default {
  install(plg) {
    plg.addPlugin('DataViewer', GalleryDataViewer);
    plg.addPlugin('BlockerHook', DefaultFiltersBlocker);
    TriggerSetup.install(plg);
    ActionSetup.install(plg);
  }
};